/**
 * Stock Check Service
 * Handles API calls to verify stock availability by SKU (matnr).
 */

if (typeof window.StockService === 'undefined') {
    window.StockService = (function () {
        const baseUrl = window.AsianPaintsConfig.baseUrl; // No fallback here
        const API_URL = baseUrl + 'stock-check';
        const cache = new Map();
        const debounceTimers = new Map();
        const lastRequestTimestamp = new Map();

        /**
         * Maps API status to UI state classes
         */
        const STATUS_MAP = {
            'available': 'state-valid',
            'partially available': 'state-exceed',
            'not available': 'state-out'
        };

        /**
         * Fetches stock from API
         */
        async function fetchStock(sku, quantity) {
            const cacheKey = `${sku}-${quantity}`;
            if (cache.has(cacheKey)) {
                return cache.get(cacheKey);
            }

            try {
                const response = await fetch(API_URL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        matnr: sku,
                        quantity: parseInt(quantity)
                    })
                });

                const result = await response.json();
                // console.log(`[StockService] API Response for ${sku} (qty ${quantity}):`, result);

                if (result.success && result.data) {
                    const stateData = {
                        status: result.data.status,
                        stateClass: STATUS_MAP[result.data.status] || '',
                        availableQty: result.data.available_qty,
                        requestedQty: result.data.requested_qty
                    };
                    cache.set(cacheKey, stateData);
                    return stateData;
                }
                return null;
            } catch (error) {
                console.error('Stock Check API Error:', error);
                return null;
            }
        }

        /**
         * Stock check with optional debounce
         */
        function check(sku, quantity, callback, immediate = false) {
            const timerKey = sku;
            const quantityInt = parseInt(quantity);
            const timestamp = Date.now();
            lastRequestTimestamp.set(sku, timestamp);

            if (quantityInt <= 0) {
                if (debounceTimers.has(timerKey)) {
                    clearTimeout(debounceTimers.get(timerKey));
                }
                callback(null);
                return;
            }

            // console.log(`[StockService] check called for ${sku}, qty: ${quantityInt}, immediate: ${immediate}, ts: ${timestamp}`);

            if (debounceTimers.has(timerKey)) {
                clearTimeout(debounceTimers.get(timerKey));
            }

            const executeFetch = async () => {
                // console.log(`[StockService] executeFetch firing for ${sku}, qty: ${quantityInt}, ts: ${timestamp}`);
                const res = await fetchStock(sku, quantityInt);

                // Race condition check: only callback if this is still the latest request
                if (lastRequestTimestamp.get(sku) === timestamp) {
                    // console.log(`[StockService] Applying response for ${sku}, qty: ${quantityInt}`);
                    callback(res);
                } else {
                    console.warn(`[StockService] Ignoring stale response for ${sku}, qty: ${quantityInt}`);
                }

                if (debounceTimers.get(timerKey) === timer) {
                    debounceTimers.delete(timerKey);
                }
            };

            let timer = null;
            if (immediate) {
                executeFetch();
            } else {
                timer = setTimeout(executeFetch, 400);
                debounceTimers.set(timerKey, timer);
            }
        }

        return {
            check
        };
    })();
}
